import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-dashboard-calendar',
  standalone: true,
  imports: [CommonModule, TooltipModule],
  template: `
    <div class="calendar-card">
      <div class="calendar-header">
        <i class="pi pi-calendar"></i>
        Tarefas do Mês
      </div>
      <div class="calendar-grid">
        <div class="calendar-day" *ngFor="let w of weekDays">
          <span class="day-number">{{ w }}</span>
        </div>
        <div *ngFor="let cell of calendarCells"
             class="calendar-day"
             [ngClass]="{
               'today': cell.day === today && cell.inCurrentMonth,
               'has-task': cell.inCurrentMonth && events[cell.day],
               'selected': cell.day === selectedDay && cell.inCurrentMonth,
               'urgent': cell.inCurrentMonth && events[cell.day]?.isDeadline
             }"
             (click)="cell.inCurrentMonth && onSelectDay(cell.day)">
          <div class="day-header">
            <span class="day-number">{{ cell.day || '' }}</span>
            <span *ngIf="cell.inCurrentMonth && cell.day === today" class="today-badge">Hoje</span>
          </div>
          <ng-container *ngIf="cell.inCurrentMonth && events[cell.day]">
            <div class="tasks-panel">
              <button class="task-badge-btn"
                      [ngClass]="{
                        'urgent': events[cell.day].isDeadline,
                        'reminder': !events[cell.day].isDeadline
                      }"
                      [pTooltip]="events[cell.day].title"
                      tooltipPosition="top"
                      appendTo="body">
                <i class="pi" [ngClass]="events[cell.day].isDeadline ? 'pi-exclamation-triangle' : 'pi-bell'"></i>
                <span class="task-message">{{ events[cell.day].title }}</span>
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./dashboard-calendar.component.scss']
})
export class DashboardCalendarComponent {
  weekDays = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'];
  today = new Date().getDate();
  year = new Date().getFullYear();
  month = new Date().getMonth();
  selectedDay: number | null = null;
  calendarCells: { day: number | null; inCurrentMonth: boolean }[] = [];
  events: { [key: number]: { title: string; isDeadline: boolean } } = {};

  constructor() {
    this.buildCalendar();
    this.buildEvents();
  }

  private buildCalendar() {
    const firstDay = new Date(this.year, this.month, 1);
    const lastDay = new Date(this.year, this.month + 1, 0);
    const startWeekday = (firstDay.getDay() + 6) % 7;
    const totalDays = lastDay.getDate();
    const cells: { day: number | null; inCurrentMonth: boolean }[] = [];
    for (let i = 0; i < startWeekday; i++) cells.push({ day: null, inCurrentMonth: false });
    for (let d = 1; d <= totalDays; d++) cells.push({ day: d, inCurrentMonth: true });
    while (cells.length % 7 !== 0) cells.push({ day: null, inCurrentMonth: false });
    this.calendarCells = cells;
  }

  private nextBusinessDay(date: Date): Date {
    const d = new Date(date);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    return d;
  }

  private buildEvents() {
    const d5 = this.nextBusinessDay(new Date(this.year, this.month, 5));
    const d20 = this.nextBusinessDay(new Date(this.year, this.month, 20));
    const e: { [key: number]: { title: string; isDeadline: boolean } } = {};
    if (d5.getMonth() === this.month) e[d5.getDate()] = { title: 'Importação Extratos e Importação NFS-e emitidas fora do sistema', isDeadline: true };
    if (d20.getMonth() === this.month) e[d20.getDate()] = { title: 'Prazo final para pagamentos de tributos', isDeadline: false };
    this.events = e;
  }

  onSelectDay(day: number) {
    this.selectedDay = day;
  }
}